import styled from 'styled-components';
import { layout } from 'src/components/base';
import { ToggleButton } from '@prisjakt/ui/button/variants';

export const ButtonWrapper = styled.div`
  display: flex;
  gap: ${layout.measurements.spacing050};
`;

export const StyledToggleButton = styled(ToggleButton)`
  min-width: 80px;
`;

export const ConditionHeader = styled.div`
  margin: 0 0 ${layout.measurements.spacing075};
`;
